import * as React from "react";
import { Form, Button, Breadcrumb, Input, DatePicker, Radio } from "antd";
import "antd/dist/antd.css";
import { SendOutlined } from "@ant-design/icons";
import DataSource, {
  DATE_DISPLAY_FORMAT,
  DATE_SUBMIT_FORMAT,
} from "../lib/DataSource";
import { Link, RouteComponentProps } from "react-router-dom";
import moment from "moment";

const { TextArea } = Input;

export default class EditFinanceRecord extends React.Component<
  { id: number; route: RouteComponentProps },
  {
    loading: boolean;
    studentName: any;
    record: any;
  }
> {
  contentType = "finance";

  constructor(props) {
    super(props);
    this.state = { loading: true, studentName: "", record: "" };
  }

  componentWillMount() {
    // this.loadStudentData();
    this.loadFinance();
  }

  loadStudentData() {
    this.setState({ loading: true });
    DataSource.loadData("student", this.props.id).then((data) => {
      this.setState({
        studentName: data.student_name,
        record: data.record,
        loading: false,
      });
    });
  }

  loadFinance() {
    this.setState({ loading: true });
    DataSource.loadFinanceRecordData(this.props.id).then((data) => {
      this.setState({
        studentName: data.student_name,
        record: data.record,
        loading: false,
      });
    });
  }

  handleSubmit(values) {
    if (values.date) {
      values.date = values.date.format(DATE_SUBMIT_FORMAT);
    }

    values.amount = parseFloat(values.amount);
    let url = "icd/finance/update-record/" + this.props.id;
    DataSource.submitData(url, values).then((result) => {
      this.props.route.history.push(
        "/finance/records/" + this.state.record.student_id,
      );
    });
  }

  render() {
    if (this.state.loading) {
      return <div className="loading"></div>;
    }

    let { studentName, record } = this.state;

    return (
      <div id="create-finance-record">
        <h2>Update a Finance Record</h2>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/finance/list">Fee</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={"/finance/records/" + this.state.record.student_id}>
              {this.state.studentName}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Edit</Breadcrumb.Item>
        </Breadcrumb>
        <Form
          className="icd-form"
          name="add-finance-record"
          onFinish={this.handleSubmit.bind(this)}
        >
          <Form.Item label="Student">{studentName}</Form.Item>
          <Form.Item
            label="Category"
            name="category"
            initialValue={record.category}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Record Type"
            name="type"
            required={true}
            initialValue={record.payment_type}
          >
            <Radio.Group>
              <Radio value={1}>Fee</Radio>
              <Radio value={2}>Payment</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="Amount" name="amount" initialValue={record.amount}>
            <Input type="number" />
          </Form.Item>
          <Form.Item
            label="Date"
            name="date"
            initialValue={moment(record.date)}
          >
            <DatePicker format={DATE_DISPLAY_FORMAT} />
          </Form.Item>
          <Form.Item
            label="Ref no"
            name="reference_no"
            initialValue={record.reference_no}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Comment"
            name="comment"
            initialValue={record.comment}
          >
            <TextArea />
          </Form.Item>
          <Button type="primary" icon={<SendOutlined />} htmlType="submit">
            Update Record
          </Button>{" "}
          &nbsp;&nbsp;&nbsp;
          <Link to={"/finance/records/" + this.state.record.student_id}>
            Cancel
          </Link>
        </Form>
      </div>
    );
  }
}
